import ListCell from '@doordash/component-list-cell'
import { Spacing } from '@doordash/design-language'
import styled from 'styled-components'

export const DocumentListCell = styled(ListCell).attrs({
  size: ListCell.Sizes.Small,
  iconEnd: { type: ListCell.IconTypes.ChevronRight },
})``

export const DocumentListCellWrapper = styled.div`
  margin-left: -${Spacing.Small}px;
  margin-right: -${Spacing.Small}px;
`
